import { PulseFilters, pulseFiltersSchema } from './types'

import { api } from 'api'
import { z } from 'zod'

const shiftNoticeTimeseriesResponse = z.array(
  z.object({
    shift_date: z.string(),
    workers_needed_final: z.number(),
    notice_category: z.string(),
  })
)

export type ShiftNoticeTimeseries = z.infer<
  typeof shiftNoticeTimeseriesResponse
>

export async function getShiftNoticeTimeseries(
  filters: PulseFilters,
  signal?: AbortSignal
) {
  const data = pulseFiltersSchema.parse(filters)

  return await api
    .post('/company/pulse/operations/shift_notice_timeseries', data, { signal })
    .then((response) => response.data)
    .then(shiftNoticeTimeseriesResponse.parse)
}

export async function getShiftNoticeTimeseriesCsv(
  filters: PulseFilters,
  signal?: AbortSignal
) {
  const data = pulseFiltersSchema.parse(filters)

  return await api
    .post('/company/pulse/operations/shift_notice_timeseries/csv', data, {
      signal,
    })
    .then((response) => response.data)
}
